import ProductCard, {ProductCardProps} from './ProductCard';
export default ProductCard;

export {ProductCardProps};
